// extracted by mini-css-extract-plugin
export var leftAlign = "_27-2";
export var popper = "_27-0";
export var subtitle = "_27-1";